import {UI} from "../../../../stem-core/src/ui/UIBase";
import {styleRule, styleRuleInherit, StyleSheet} from "../../../../stem-core/src/ui/Style";

import {Messages} from "../../../Messages";
import {SocialLoginButtons} from "../../../website/unauthenticated/slides/SocialLoginButtons";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {
    GenericSignUpPasswordless,
    GenericSignUpPasswordlessStyle
} from "../../../website/unauthenticated/slides/GenericSignUpPasswordless";
import {BlinkInput, BlinkInputStyle} from "../../../ui/Input";
import {MerchantButton} from "../../../common/MerchantButton";
import {DONATE_PAGE_URLS} from "../../PaywallConstants";
import {PoweredByBlink} from "../../PoweredByBlink";
import {StepDescription} from "../StepDescription";
import {authService, userService} from "../../../../client/connection/Services";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {PaymentMethodStore} from "../../../State";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {iFrameState} from "../../../services/IFrameState";


class AuthEmailInputStyle extends BlinkInputStyle {
    @styleRuleInherit
    input = {
        marginTop: 0,
    };

    @styleRuleInherit
    inputContainer = this.themeProps.DONATE_PAGE_INPUT_CONTAINER;

    @styleRuleInherit
    label = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        marginTop: 0,
        marginBottom: 10,
    };

    @styleRuleInherit
    errorMessage = {
        top: 0,
        right: 0,
        left: "auto",
        transform: "translateY(-100%)",
    }
}

@registerStyle(AuthEmailInputStyle)
class AuthEmailInput extends BlinkInput {}

class AuthHomeEmailSectionStyle extends GenericSignUpPasswordlessStyle {
    @styleRuleInherit
    button = {
        ...this.themeProps.DONATE_PAGE_BUTTON,
        marginBottom: 20,
        marginTop: 18,
    }
}

@registerStyle(AuthHomeEmailSectionStyle)
export class AuthHomeEmailSection extends GenericSignUpPasswordless {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            emailInputLabel: Messages.emailAddress,
            emailButtonLabel: Messages.continueToPayment,
            InputClass: AuthEmailInput,
            ButtonClass: MerchantButton,
        };
    }
}

class AuthenticationStyle extends StyleSheet {
    @styleRule
    authHomeDonation = {
        ...this.themeProps.AUTH_HOME_DONATION,
        maxWidth: "",
    };

    @styleRule
    authHomeSocial = {
        textAlign: "center",
        marginBottom: 12,
    };

    @styleRule
    socialButtons = {
        margin: "auto",
        maxWidth: 282,
    };

    @styleRule
    authHomeEmail = {
        textAlign: "center",
        margin: "18px auto",
    };

    @styleRule
    authEmailSection = {
        marginBottom: -18,
    };
}

export function donatePageOnAuthenticate(element) {
    authService.onAuthenticationChange(() => {
        if (element.isInDocument() && authService.isAuthenticated()) {
            LoadingSpinner.show();
            userService.ensureUserDataRequested(() => {
                LoadingSpinner.hide();
                if (iFrameUserDataService.getActiveRecurringDonation()) {
                    element.options.changeURL(DONATE_PAGE_URLS.recurringDonor);
                } else if (!PaymentMethodStore.getPrimary()) {
                    element.options.changeURL(DONATE_PAGE_URLS.payWithAddedCard);
                } else {
                    element.options.changeURL(DONATE_PAGE_URLS.payWithChosenCard);
                }
            });
        }
    });
}

@registerStyle(AuthenticationStyle)
export class AuthenticationPanel extends UI.Element {
    render() {
        const {styleSheet} = this;

        return [
            <StepDescription backFunction={() => this.options.changeURL(DONATE_PAGE_URLS.donate, true)}
                             currentStep={2} stepDescription={Messages.authenticate}/>,
            <MessageElement className={styleSheet.authHomeDonation}
                            message={Messages.authHomeDonation(iFrameMerchantService.getMerchant().name)} />,
            <div className={styleSheet.authHomeSocial}>{Messages.authHomeSocial}</div>,
            <SocialLoginButtons className={styleSheet.socialButtons} label={""} socialApps={iFrameState.authSocialProviders}/>,
            <div className={styleSheet.authHomeEmail}>{Messages.donatePageAuthHomeEmail}</div>,
            <AuthHomeEmailSection onSignUpAction={() => this.options.changeURL(DONATE_PAGE_URLS.confirmCode)}
                                  className={styleSheet.authEmailSection}/>,
            <PoweredByBlink/>,
        ];
    }

    onMount() {
        super.onMount();
        donatePageOnAuthenticate(this);
    }
}
